module.exports = __webpack_public_path__ + "images/xl_guizhou.png?9b5abef429f0e2723abbd5898c85e73b";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_guizhou.png
// module id = 239
// module chunks = 1